import MasterTable from "../../views/dashboard/widget/MasterTabel";
import { useGlobalState } from "../../services/hostelConst.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getDivisionDetails,
  getDivisionList,
  updateDivisionStatus,
  deleteDivision,
  updateDivision,
} from "../../services/Academic-Services";
import AddClassesForm from "../../components/FormComponents/AddClasses.js";
const DivisionsTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });

    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getDivisionList}
        deleteRow={deleteDivision}
        updateStatus={updateDivisionStatus}
        tab1={"Academic"}
        tab2={"Divisions"}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
      />
    </>
  );
};

export default DivisionsTable;
